import { ReactElement } from "react";

import { ProgressIndicator } from "@sabre/spark-react-core";
import { ProgressIndicatorSize, ProgressIndicatorType } from "@sabre/spark-react-core/types";

const SplashScreen = (): ReactElement => (
  <div className="spark-content__wrapper--sticky-footer">
    <article className="spark-splash-screen spark-main--sticky-footer">
      <section className="spark-splash-screen__content">
        <div className="spark-splash-screen__center">
          <i className="spark-logo spark-logo--sabre spark-logo--lg">Sabre</i>
          <h1 className="spark-splash-screen__heading">Offer Optimization</h1>
          <ProgressIndicator
            className="spark-mar-t-1 spark-inline-block"
            size={ProgressIndicatorSize.EXTRA_SMALL}
            type={ProgressIndicatorType.INDETERMINATE}
          />
        </div>
      </section>
    </article>
  </div>
);

export default SplashScreen;
